// // import React, { useEffect, useRef, useState } from 'react';
// // import { Box, TextField, FormControl, Select, MenuItem, Checkbox, ListItemText, Divider, Typography } from '@mui/material';
// // import FormGroup from '@mui/material/FormGroup';
// // import FormControlLabel from '@mui/material/FormControlLabel';
// // import REPORTS_URL from '../config';


// // const Filters = ({
// //   searchTerm, setSearchTerm, statusFilters, setStatusFilters, departmentFilters, setDepartmentFilters, assignedFilters, setAssignedFilters,
// //   dateRange, setDateRange, dropdownOpen, setDropdownOpen
// // }) => {
// //   const [statusOptions, setStatusOptions] = useState(['Passed', 'Failed', 'Missed']);
// //   const [departmentOptions, setDepartmentOptions] = useState([]); // Update to store {id, name} objects
// //   const [assignedOptions, setAssignedOptions] = useState([]);
// //   const dropdownRef = useRef(null);

// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setDropdownOpen(false);
// //     };
// //     if (dropdownOpen) document.addEventListener('mousedown', handleClickOutside);
// //     return () => document.removeEventListener('mousedown', handleClickOutside);
// //   }, [dropdownOpen]);

// //   useEffect(() => {
// //     const fetchOptions = async () => {
// //       try {
// //         const response = await fetch(`/reports/filter-options/`);
// //         const data = await response.json();
// //         // Store departments as array of {id, name} objects
// //         setDepartmentOptions(Object.entries(data.departments || {}).map(([id, name]) => ({ id, name })));
// //         setAssignedOptions(Object.values(data.assignment_types || []));
// //       } catch (error) {
// //         console.error('Error fetching filter options:', error);
// //       }
// //     };
// //     fetchOptions();
// //   }, []);

// //   const handleStatusChange = (status) => setStatusFilters(prev => prev.includes(status) ? prev.filter(s => s !== status) : [...prev, status]);
// //   const handleDepartmentChange = (id) => setDepartmentFilters(prev => prev.includes(id) ? prev.filter(d => d !== id) : [...prev, id]); // Use IDs
// //   const handleAssignedChange = (assigned) => setAssignedFilters(prev => prev.includes(assigned) ? prev.filter(a => a !== assigned) : [...prev, assigned]);
// //   const handleDateChange = (e) => setDateRange({ ...dateRange, [e.target.name]: e.target.value });

// //   return (
// //     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 2 }}>
// //       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}>
// //         <TextField variant="outlined" size="small" placeholder="Search by Name, Status, Department, or Assigned" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} sx={{ width: 400, '& .MuiOutlinedInput-root': { height: '40px', fontSize: '0.875rem', background: 'white', '& fieldset': { borderColor: '#666' }, '&:hover fieldset': { borderColor: '#007bff' }, '&.Mui-focused fieldset': { borderColor: '#007bff' } } }} />
// //         <FormControl sx={{ minWidth: 180 }}>
// //           <Select multiple value={[]} displayEmpty renderValue={() => { const total = statusFilters.length + departmentFilters.length + assignedFilters.length; return total === 0 ? 'All Filters' : `Filters (${total})`; }} sx={{ height: '40px', fontSize: '0.875rem', background: 'white', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#666' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#007bff' }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#007bff' }, '& .MuiSelect-select': { padding: '4px 12px 8px 1px' } }} MenuProps={{ PaperProps: { sx: { zIndex: 1500, maxHeight: 400, width: 600, background: 'white', border: '2px solid #007bff', borderRadius: '8px', boxShadow: '0px 8px 24px rgba(0,0,0,0.15)', '& .MuiList-root': { padding: 0 } } } }}>
// //             <Box sx={{ p: 3 }}>
// //               <Box sx={{ display: 'flex', gap: 4 }}>
// //                 <Box sx={{ minWidth: 150 }}>
// //                   <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Status</Typography>
// //                   <FormGroup>
// //                     {statusOptions.map(status => <FormControlLabel key={status} control={<Checkbox checked={statusFilters.includes(status)} onChange={() => handleStatusChange(status)} size="small" />} label={status} sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } }} />)}
// //                   </FormGroup>
// //                 </Box>
// //                 <Box sx={{ minWidth: 150 }}>
// //                   <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Department</Typography>
// //                   <FormGroup>
// //                     {departmentOptions.map(dept => <FormControlLabel key={dept.id} control={<Checkbox checked={departmentFilters.includes(dept.id)} onChange={() => handleDepartmentChange(dept.id)} size="small" />} label={dept.name} sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } }} />)}
// //                   </FormGroup>
// //                 </Box>
// //                 <Box sx={{ minWidth: 180 }}>
// //                   <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Assigned</Typography>
// //                   <FormGroup>
// //                     {assignedOptions.map(assigned => <FormControlLabel key={assigned} control={<Checkbox checked={assignedFilters.includes(assigned)} onChange={() => handleAssignedChange(assigned)} size="small" />} label={assigned} sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } }} />)}
// //                   </FormGroup>
// //                 </Box>
// //               </Box>
// //             </Box>
// //           </Select>
// //         </FormControl>
// //         <Box sx={{ position: 'relative', minWidth: 180 }} ref={dropdownRef}>
// //           <Box onClick={() => setDropdownOpen(!dropdownOpen)} sx={{ height: '40px', fontSize: '0.875rem', background: 'white', border: '1px solid #666', borderRadius: '4px', padding: '8px 12px', display: 'flex', alignItems: 'center', cursor: 'pointer', '&:hover': { borderColor: '#007bff' } }}>
// //             <i className="fa fa-calendar-o" style={{ marginRight: '8px' }}></i> Specific Date Range
// //           </Box>
// //           {dropdownOpen && (
// //             <Box sx={{ position: 'absolute', top: '100%', left: 0, zIndex: 1500, background: 'white', border: '2px solid #007bff', borderRadius: '8px', boxShadow: '0px 8px 24px rgba(0,0,0,0.15)', width: '100%', minWidth: 200, p: 2 }}>
// //               <Typography variant="caption">From</Typography>
// //               <input type="date" name="from" className="form-control" value={dateRange.from} onChange={handleDateChange} style={{ width: '100%', padding: '4px', border: '1px solid #666', borderRadius: '4px' }} />
// //               <Typography variant="caption">To</Typography>
// //               <input type="date" name="to" className="form-control" value={dateRange.to} onChange={handleDateChange} style={{ width: '100%', padding: '4px', border: '1px solid #666', borderRadius: '4px' }} />
// //             </Box>
// //           )}
// //         </Box>
// //       </Box>
// //     </Box>
// //   );
// // };
// // export default Filters;




// // import React, { useEffect, useRef, useState } from 'react';
// // import { Box, TextField, FormControl, Select, MenuItem, Checkbox, ListItemText, Divider, Typography } from '@mui/material';
// // import FormGroup from '@mui/material/FormGroup';
// // import FormControlLabel from '@mui/material/FormControlLabel';
// // import SearchIcon from '@mui/icons-material/Search';
// // import REPORTS_URL from '../config';

// // const Filters = ({
// //   searchTerm, setSearchTerm, statusFilters, setStatusFilters, departmentFilters, setDepartmentFilters, assignedFilters, setAssignedFilters,
// //   dateRange, setDateRange, dropdownOpen, setDropdownOpen
// // }) => {
// //   const [statusOptions, setStatusOptions] = useState(['Passed', 'Failed', 'Missed']);
// //   const [departmentOptions, setDepartmentOptions] = useState([]); // Update to store {id, name} objects
// //   const [assignedOptions, setAssignedOptions] = useState([]);
// //   const dropdownRef = useRef(null);

// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setDropdownOpen(false);
// //     };
// //     if (dropdownOpen) document.addEventListener('mousedown', handleClickOutside);
// //     return () => document.removeEventListener('mousedown', handleClickOutside);
// //   }, [dropdownOpen]);

// //   useEffect(() => {
// //     const fetchOptions = async () => {
// //       try {
// //         const response = await fetch(`/reports/filter-options/`);
// //         const data = await response.json();
// //         // Store departments as array of {id, name} objects
// //         setDepartmentOptions(Object.entries(data.departments || {}).map(([id, name]) => ({ id, name })));
// //         setAssignedOptions(Object.values(data.assignment_types || []));
// //       } catch (error) {
// //         console.error('Error fetching filter options:', error);
// //       }
// //     };
// //     fetchOptions();
// //   }, []);

// //   useEffect(()=>{
// //     console.log("departmentOptions",departmentOptions,assignedOptions,"assignedoptions");
// //   },[departmentOptions,assignedOptions])

// //   const handleStatusChange = (status) => setStatusFilters(prev => prev.includes(status) ? prev.filter(s => s !== status) : [...prev, status]);
// //   const handleDepartmentChange = (id) => setDepartmentFilters(prev => prev.includes(id) ? prev.filter(d => d !== id) : [...prev, id]); // Use IDs
// //   const handleAssignedChange = (assigned) => setAssignedFilters(prev => prev.includes(assigned) ? prev.filter(a => a !== assigned) : [...prev, assigned]);
// //   const handleDateChange = (e) => setDateRange({ ...dateRange, [e.target.name]: e.target.value });

// //   return (
// //     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 2 }}>
// //       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1 }}>
// //         {/* Updated Search Bar */}
// //         <TextField
// //           variant="outlined"
// //           size="small"
// //           placeholder="Search by Name, Status, Department, or Assigned"
// //           value={searchTerm}
// //           onChange={(e) => setSearchTerm(e.target.value)}
// //           sx={{
// //             minWidth: 280,
// //             maxWidth: 450,
// //             flexGrow: 1,
// //             '& .MuiOutlinedInput-root': {
// //               height: '40px',
// //               fontSize: '0.875rem',
// //               background: 'white',
// //               '& fieldset': { borderColor: 'black' },
// //               '&:hover fieldset': { borderColor: 'black' },
// //               '&.Mui-focused fieldset': { borderColor: 'black' }
// //             }
// //           }}
// //           InputProps={{
// //             startAdornment: <SearchIcon sx={{ color: "text.secondary", mr: 1, fontSize: "1.2rem" }} />,
// //           }}
// //         />

// //         <FormControl sx={{ minWidth: 180 }}>
// //           <Select
// //             multiple
// //             value={[]}
// //             displayEmpty
// //             renderValue={() => {
// //               const total = statusFilters.length + departmentFilters.length + assignedFilters.length;
// //               return total === 0 ? 'All Filters' : `Filters (${total})`;
// //             }}
// //             sx={{
// //               height: '40px',
// //               fontSize: '0.875rem',
// //               background: 'white',
// //               '& .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
// //               '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
// //               '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
// //               '& .MuiSelect-select': { padding: '4px 12px 8px 1px' }
// //             }}
// //             MenuProps={{
// //               PaperProps: {
// //                 sx: {
// //                   zIndex: 1500,
// //                   maxHeight: 400,
// //                   width: 600,
// //                   background: 'white',
// //                   border: '2px solid black',  // Changed from #007bff to black
// //                   borderRadius: '8px',
// //                   boxShadow: '0px 8px 24px rgba(0,0,0,0.15)',
// //                   '& .MuiList-root': { padding: 0 }
// //                 }
// //               }
// //             }}
// //           >
// //             <Box sx={{ p: 3 }}>
// //               <Box sx={{ display: 'flex', gap: 4 }}>
// //                 <Box sx={{ minWidth: 150 }}>
// //                   <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Status</Typography>
// //                   <FormGroup>
// //                     {statusOptions.map(status => <FormControlLabel key={status} control={<Checkbox checked={statusFilters.includes(status)} onChange={() => handleStatusChange(status)} size="small" />} label={status} sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } }} />)}
// //                   </FormGroup>
// //                 </Box>
// //                 <Box sx={{ minWidth: 150 }}>
// //                   <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Department</Typography>
// //                   <FormGroup>
// //                     {departmentOptions.map(dept => <FormControlLabel key={dept.id} control={<Checkbox checked={departmentFilters.includes(dept.id)} onChange={() => handleDepartmentChange(dept.id)} size="small" />} label={dept.name} sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } }} />)}
// //                   </FormGroup>
// //                 </Box>
// //                 <Box sx={{ minWidth: 180 }}>
// //                   <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Assigned</Typography>
// //                   <FormGroup>
// //                     {assignedOptions.map(assigned => <FormControlLabel key={assigned} control={<Checkbox checked={assignedFilters.includes(assigned)} onChange={() => handleAssignedChange(assigned)} size="small" />} label={assigned} sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.875rem' } }} />)}
// //                   </FormGroup>
// //                 </Box>
// //               </Box>
// //             </Box>
// //           </Select>
// //         </FormControl>

// //         <Box sx={{ position: 'relative', minWidth: 180 }} ref={dropdownRef}>
// //           <Box
// //             onClick={() => setDropdownOpen(!dropdownOpen)}
// //             sx={{
// //               height: '40px',
// //               fontSize: '0.875rem',
// //               background: 'white',
// //               border: '1px solid black',  // Changed from #666 to black
// //               borderRadius: '4px',
// //               padding: '8px 12px',
// //               display: 'flex',
// //               alignItems: 'center',
// //               cursor: 'pointer',
// //               '&:hover': { borderColor: 'black' }  // Changed from #007bff to black
// //             }}
// //           >
// //             <i className="fa fa-calendar-o" style={{ marginRight: '8px' }}></i> Specific Date Range
// //           </Box>
// //           {dropdownOpen && (
// //             <Box sx={{
// //               position: 'absolute',
// //               top: '100%',
// //               left: 0,
// //               zIndex: 1500,
// //               background: 'white',
// //               border: '2px solid black',  // Changed from #007bff to black
// //               borderRadius: '8px',
// //               boxShadow: '0px 8px 24px rgba(0,0,0,0.15)',
// //               width: '100%',
// //               minWidth: 200,
// //               p: 2
// //             }}>
// //               <Typography variant="caption">From</Typography>
// //               <input
// //                 type="date"
// //                 name="from"
// //                 className="form-control"
// //                 value={dateRange.from}
// //                 onChange={handleDateChange}
// //                 style={{
// //                   width: '100%',
// //                   padding: '4px',
// //                   border: '1px solid black',  // Changed from #666 to black
// //                   borderRadius: '4px'
// //                 }}
// //               />
// //               <Typography variant="caption">To</Typography>
// //               <input
// //                 type="date"
// //                 name="to"
// //                 className="form-control"
// //                 value={dateRange.to}
// //                 onChange={handleDateChange}
// //                 style={{
// //                   width: '100%',
// //                   padding: '4px',
// //                   border: '1px solid black',  // Changed from #666 to black
// //                   borderRadius: '4px'
// //                 }}
// //               />
// //             </Box>
// //           )}
// //         </Box>
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default Filters;



// import React, { useEffect, useRef, useState } from 'react';
// import {
//   Box, TextField, Typography
// } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';

// // Syncfusion QueryBuilder imports
// import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
// import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
// import '@syncfusion/ej2-base/styles/material.css';
// import '@syncfusion/ej2-buttons/styles/material.css';
// import '@syncfusion/ej2-popups/styles/material.css';
// import '@syncfusion/ej2-splitbuttons/styles/material.css';
// import '@syncfusion/ej2-inputs/styles/material.css';
// import '@syncfusion/ej2-lists/styles/material.css';
// import '@syncfusion/ej2-dropdowns/styles/material.css';
// import '@syncfusion/ej2-calendars/styles/material.css';
// import '@syncfusion/ej2-navigations/styles/material.css';
// import '@syncfusion/ej2-querybuilder/styles/material.css';

// const Filters = ({
//   searchTerm, setSearchTerm, statusFilters, setStatusFilters,
//   departmentFilters, setDepartmentFilters, assignedFilters, setAssignedFilters,
//   dateRange, setDateRange, dropdownOpen, setDropdownOpen,
//   filterRule, setFilterRule,   // new props
//   setGroupEmployeeFilter
// }) => {
//   const [statusOptions, setStatusOptions] = useState(['Passed', 'Failed', 'Missed']);
//   const [departmentOptions, setDepartmentOptions] = useState([]);
//   const [assignedOptions, setAssignedOptions] = useState([]);
//   const [groupOptions, setGroupOptions] = useState([]);
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [groupEmployees, setGroupEmployees] = useState([]);
//   const [groupsLoading, setGroupsLoading] = useState(false);
//   const [employeesLoading, setEmployeesLoading] = useState(false);
//   const dropdownRef = useRef(null);

//   // QueryBuilder state
//   const [showFilters, setShowFilters] = useState(false);
//   const qbRef = useRef(null);
//   const currentRuleRef = useRef({ condition: 'and', rules: [] });

//   // Columns for QueryBuilder (field names must match report object keys)

//   const stringOperators = [
//     { value: 'contains', key: 'Contains' },
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'startswith', key: 'Starts With' },
//     { value: 'endswith', key: 'Ends With' },
//     { value: 'isempty', key: 'Is Empty' },
//     { value: 'isnotempty', key: 'Is Not Empty' }
//   ];

//   const numberOperators = [
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'greaterthan', key: 'Greater Than' },
//     { value: 'greaterthanorequal', key: 'Greater Than Or Equal' },
//     { value: 'lessthan', key: 'Less Than' },
//     { value: 'lessthanorequal', key: 'Less Than Or Equal' },
//     { value: 'isempty', key: 'Is Empty' },
//     { value: 'isnotempty', key: 'Is Not Empty' }
//   ];

//   const dateOperators = [
//     { value: 'equal', key: 'Equal' },
//     { value: 'notequal', key: 'Not Equal' },
//     { value: 'greaterthan', key: 'After' },
//     { value: 'lessthan', key: 'Before' },
//     { value: 'greaterthanorequal', key: 'On or After' },
//     { value: 'lessthanorequal', key: 'On or Before' },
//     { value: 'between', key: 'Between' },
//     { value: 'isempty', key: 'Is Empty' },
//     { value: 'isnotempty', key: 'Is Not Empty' }
//   ];

//   const groupValueTemplate = {
//     create: () => {
//       const select = document.createElement('select');
//       select.style.minWidth = '220px';
//       select.style.height = '36px';
//       select.style.border = 'none';
//       select.style.borderBottom = '1px solid #999';
//       select.style.background = 'transparent';
//       select.style.outline = 'none';
//       select.style.fontSize = '14px';
//       return select;
//     },
//     write: (args) => {
//       const select = Array.isArray(args.elements) ? args.elements[0] : args.elements;
//       if (!select) return;

//       const currentValue = Array.isArray(args.values) ? args.values[0] : args.values;
//       select.innerHTML = '';

//       const placeholder = document.createElement('option');
//       placeholder.value = '';
//       placeholder.textContent = groupsLoading ? 'Loading groups...' : 'Select Group';
//       placeholder.disabled = true;
//       select.appendChild(placeholder);

//       groupOptions.forEach((group) => {
//         const option = document.createElement('option');
//         option.value = group.name;
//         option.textContent = group.name;
//         select.appendChild(option);
//       });

//       select.value = currentValue || '';
//       select.onchange = (event) => {
//         qbRef.current?.notifyChange(event.target.value, event.target, 'value');
//       };
//     },
//     destroy: (element) => {
//       if (element) element.onchange = null;
//     }
//   };

//   const queryBuilderColumns = [
//     { field: 'name', label: 'Name', type: 'string', operators: stringOperators },
//     { field: 'status', label: 'Status', type: 'string', operators: stringOperators },
//     { field: 'department', label: 'Department', type: 'string', operators: stringOperators },
//     { field: 'assigned', label: 'Assigned', type: 'string', operators: stringOperators },
//     {
//       field: 'group_name',
//       label: 'Group',
//       type: 'string',
//       operators: [{ value: 'equal', key: 'Equal' }],
//       values: groupOptions.map(group => group.name),
//       template: groupValueTemplate
//     },
//     { field: 'percentage', label: 'Percentage', type: 'number', operators: numberOperators},
//     { field: 'obtained_marks', label: 'Obtained Marks', type: 'number', operators: numberOperators },
//     { field: 'total_marks', label: 'Total Marks', type: 'number', operators: numberOperators }
//     // { field: 'percentage', label: 'Score', type: 'number', operators: numberOperators },
//     // { field: 'exam_end_time', label: 'Date', type: 'date', format: 'yyyy-MM-dd', operators: dateOperators },
//   ];

//   const defaultRule = { condition: 'and', rules: [] };

//   const hasGroupCondition = (rule) => {
//     if (!rule?.rules?.length) return false;

//     return rule.rules.some((subRule) =>
//       subRule?.rules?.length
//         ? hasGroupCondition(subRule)
//         : subRule?.field === 'group_name'
//     );
//   };

//   const getGroupRuleValue = (rule) => {
//     if (!rule?.rules?.length) return null;

//     for (const subRule of rule.rules) {
//       if (subRule?.rules?.length) {
//         const nestedValue = getGroupRuleValue(subRule);
//         if (nestedValue) return nestedValue;
//         continue;
//       }

//       if (subRule?.field === 'group_name') {
//         if (Array.isArray(subRule.value)) return subRule.value[0] || null;
//         return subRule.value || null;
//       }
//     }

//     return null;
//   };

//   const syncSelectedGroupFromRule = (rule, options = groupOptions) => {
//     if (!hasGroupCondition(rule)) {
//       setSelectedGroup(null);
//       setGroupEmployees([]);
//       setGroupEmployeeFilter(null);
//       return;
//     }

//     const groupValue = getGroupRuleValue(rule);
//     const nextSelectedGroup = options.find(group => group.name === groupValue) || null;

//     setSelectedGroup(nextSelectedGroup);
//     if (!nextSelectedGroup) {
//       setGroupEmployees([]);
//       setGroupEmployeeFilter(null);
//     }
//   };

//   const removeGroupRules = (rule) => {
//     if (!rule?.rules?.length) return rule;

//     const rules = rule.rules
//       .map((subRule) => subRule?.rules?.length ? removeGroupRules(subRule) : subRule)
//       .filter((subRule) => {
//         if (subRule?.rules) return subRule.rules.length > 0;
//         return subRule?.field !== 'group_name';
//       });

//     return { ...rule, rules };
//   };

//   const applyFilters = () => {
//     const rule = currentRuleRef.current || defaultRule;
//     setFilterRule(removeGroupRules(rule));
//     const groupValue = getGroupRuleValue(rule);
//     const groupFromRule = groupOptions.find(group => group.name === groupValue) || selectedGroup;
//     const isSelectedGroupReady = selectedGroup && groupFromRule?.groupUid === selectedGroup.groupUid;

//     if (groupFromRule && isSelectedGroupReady && groupEmployees.length) {
//       const employees = Array.from(
//         new Map(
//           groupEmployees.map(emp => [emp.employee_guid, {
//             employee_guid: emp.employee_guid,
//             name: emp.name,
//             employee_id: emp.employee_id
//           }])
//         ).values()
//       );

//       setGroupEmployeeFilter({
//         groups: [{
//           group_uid: groupFromRule.groupUid,
//           group_name: groupFromRule.name,
//           employees
//         }]
//       });
//       return;
//     }

//     setGroupEmployeeFilter(null);
//   };

//   const clearAllFilters = () => {
//     setSearchTerm('');
//     setFilterRule(null);
//     setSelectedGroup(null);
//     setGroupEmployees([]);
//     setGroupEmployeeFilter(null);
//     if (qbRef.current) {
//       qbRef.current.setRules(defaultRule);
//       currentRuleRef.current = defaultRule;
//     }
//   };

//   // Existing useEffect for click outside dropdown
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setDropdownOpen(false);
//     };
//     if (dropdownOpen) document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [dropdownOpen]);

//   // Fetch filter options
//   useEffect(() => {
//     const fetchOptions = async () => {
//       try {
//         const response = await fetch(`/reports/filter-options/`);
//         const data = await response.json();
//         setDepartmentOptions(Object.entries(data.departments || {}).map(([id, name]) => ({ id, name })));
//         setAssignedOptions(Object.values(data.assignment_types || []));
//       } catch (error) {
//         console.error('Error fetching filter options:', error);
//       }
//     };
//     fetchOptions();
//   }, []);

//   useEffect(() => {
//     if (!showFilters) return;

//     const fetchGroups = async () => {
//       try {
//         setGroupsLoading(true);
//         const response = await fetch('/coordinators/get_groups_list/?IsActive=true&SortDescending=true');
//         const data = await response.json();

//         if (data.success) {
//           setGroupOptions((data.data || []).map(group => ({
//             id: group.GroupId,
//             groupUid: group.GroupGUID,
//             name: group.Name
//           })).filter(group => group.groupUid && group.name));
//         }
//       } catch (error) {
//         console.error('Error fetching groups:', error);
//       } finally {
//         setGroupsLoading(false);
//       }
//     };

//     fetchGroups();
//   }, [showFilters]);

//   useEffect(() => {
//     syncSelectedGroupFromRule(currentRuleRef.current, groupOptions);
//   }, [groupOptions]);

//   useEffect(() => {
//     const fetchEmployeesForGroups = async () => {
//       if (!selectedGroup) {
//         setGroupEmployees([]);
//         return;
//       }

//       try {
//         setEmployeesLoading(true);
//         const response = await fetch(
//           `/coordinators/get_groups_user_by_plant/${selectedGroup.groupUid}/?Page=1&PageSize=500&SortDescending=true`
//         );
//         const data = await response.json();

//         if (!data.success) {
//           setGroupEmployees([]);
//           return;
//         }

//         setGroupEmployees((data.data || []).map(user => ({
//           employee_guid: user.ssoUserId,
//           employee_id: user.employeeID,
//           name: user.fullName || user.employeeID || 'N/A',
//           groupUid: selectedGroup.groupUid,
//           groupName: selectedGroup.name
//         })).filter(user => user.employee_guid));
//       } catch (error) {
//         console.error('Error fetching group employees:', error);
//         setGroupEmployees([]);
//       } finally {
//         setEmployeesLoading(false);
//       }
//     };

//     fetchEmployeesForGroups();
//   }, [selectedGroup]);

//   const handleStatusChange = (status) =>
//     setStatusFilters(prev => prev.includes(status) ? prev.filter(s => s !== status) : [...prev, status]);

//   const handleDepartmentChange = (id) =>
//     setDepartmentFilters(prev => prev.includes(id) ? prev.filter(d => d !== id) : [...prev, id]);

//   const handleAssignedChange = (assigned) =>
//     setAssignedFilters(prev => prev.includes(assigned) ? prev.filter(a => a !== assigned) : [...prev, assigned]);

//   const handleDateChange = (e) => setDateRange({ ...dateRange, [e.target.name]: e.target.value });

//   return (
//     <>
//       <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 2, flexWrap: 'wrap' }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1, flexWrap: 'wrap' }}>
//           {/* Search Bar */}
//           <TextField
//             variant="outlined"
//             size="small"
//             placeholder="Search by Name, Status, Department, Percentage, Total Marks"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             sx={{
//               minWidth: 280,
//               maxWidth: 450,
//               flexGrow: 1,
//               '& .MuiOutlinedInput-root': {
//                 height: '40px',
//                 fontSize: '0.875rem',
//                 background: 'white',
//                 '& fieldset': { borderColor: 'black' },
//                 '&:hover fieldset': { borderColor: 'black' },
//                 '&.Mui-focused fieldset': { borderColor: 'black' }
//               }
//             }}
//             InputProps={{
//               startAdornment: <SearchIcon sx={{ color: "text.secondary", mr: 1, fontSize: "1.2rem" }} />,
//             }}
//           />

//           {/* Enable Filters Button */}
//           <button
//             className="btn"
//             onClick={() => {
//               if (showFilters) {
//                 if (qbRef.current) {
//                   qbRef.current.setRules(defaultRule);
//                   currentRuleRef.current = defaultRule;
//                 }

//                 setSearchTerm('');
//                 setFilterRule(null);
//                 setSelectedGroup(null);
//                 setGroupEmployees([]);
//                 setGroupEmployeeFilter(null);
//               }

//               setShowFilters(!showFilters);
//             }}
//           >
//             {showFilters ? 'Close Filters' : 'Enable Filters'}
//           </button>


//         </Box>
//       </Box>

//       {/* Syncfusion QueryBuilder (conditionally visible) */}
//       {showFilters && (
//         <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1, border: '1px solid #ddd', mb: 2 }}>
//           <QueryBuilderComponent
//             ref={qbRef}
//             key={`employee-report-qb-${groupOptions.length}`}
//             dataSource={[]}
//             columns={queryBuilderColumns}
//             rule={defaultRule}
//             ruleChange={(args) => {
//               currentRuleRef.current = args.rule;
//               syncSelectedGroupFromRule(args.rule);
//             }}
//             created={() => {
//               if (qbRef.current) qbRef.current.setRules(defaultRule);
//             }}
//             showButtons={false}
//             summaryView={false}
//           />
//           {groupsLoading && (
//             <Typography sx={{ mt: 1, fontSize: '0.85rem', color: 'text.secondary' }}>
//               Loading groups...
//             </Typography>
//           )}
//           {employeesLoading && (
//             <Typography sx={{ mt: 1, fontSize: '0.85rem', color: 'text.secondary' }}>
//               Loading group employees...
//             </Typography>
//           )}
//           {selectedGroup && !employeesLoading && (
//             <Typography sx={{ mt: 1, fontSize: '0.85rem', color: 'text.secondary' }}>
//               {groupEmployees.length} employees from {selectedGroup.name} will be included.
//             </Typography>
//           )}
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
//             <ButtonComponent cssClass="btn-negative" onClick={clearAllFilters}>
//               Clear Filters
//             </ButtonComponent>
//             <ButtonComponent cssClass="btn" onClick={applyFilters}>
//               Apply Filters
//             </ButtonComponent>
//           </Box>
//         </Box>
//       )}
//     </>
//   );
// };

// export default Filters;







// viva_ui/src/Reports/Filters.js


import React, { useEffect, useRef, useState } from 'react';
import {
  Box, TextField, Typography
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';

// Syncfusion QueryBuilder imports
import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-splitbuttons/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-lists/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-calendars/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-querybuilder/styles/material.css';

const Filters = ({
  searchTerm, setSearchTerm, statusFilters, setStatusFilters,
  departmentFilters, setDepartmentFilters, assignedFilters, setAssignedFilters,
  dateRange, setDateRange, dropdownOpen, setDropdownOpen,
  filterRule, setFilterRule,   // new props
  setGroupEmployeeFilter,
  extraActions = null
}) => {
  const [statusOptions, setStatusOptions] = useState(['Passed', 'Failed', 'Missed']);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [assignedOptions, setAssignedOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groupEmployees, setGroupEmployees] = useState([]);
  const [groupsLoading, setGroupsLoading] = useState(false);
  const [employeesLoading, setEmployeesLoading] = useState(false);
  const dropdownRef = useRef(null);

  // QueryBuilder state
  const [showFilters, setShowFilters] = useState(false);
  const qbRef = useRef(null);
  const currentRuleRef = useRef({ condition: 'and', rules: [] });

  // Columns for QueryBuilder (field names must match report object keys)

  const stringOperators = [
    { value: 'contains', key: 'Contains' },
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'startswith', key: 'Starts With' },
    { value: 'endswith', key: 'Ends With' },
    { value: 'isempty', key: 'Is Empty' },
    { value: 'isnotempty', key: 'Is Not Empty' }
  ];

  const numberOperators = [
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'greaterthan', key: 'Greater Than' },
    { value: 'greaterthanorequal', key: 'Greater Than Or Equal' },
    { value: 'lessthan', key: 'Less Than' },
    { value: 'lessthanorequal', key: 'Less Than Or Equal' },
    { value: 'isempty', key: 'Is Empty' },
    { value: 'isnotempty', key: 'Is Not Empty' }
  ];

  const dateOperators = [
    { value: 'equal', key: 'Equal' },
    { value: 'notequal', key: 'Not Equal' },
    { value: 'greaterthan', key: 'After' },
    { value: 'lessthan', key: 'Before' },
    { value: 'greaterthanorequal', key: 'On or After' },
    { value: 'lessthanorequal', key: 'On or Before' },
    { value: 'between', key: 'Between' },
    { value: 'isempty', key: 'Is Empty' },
    { value: 'isnotempty', key: 'Is Not Empty' }
  ];

  const groupValueTemplate = {
    create: () => {
      const select = document.createElement('select');
      select.style.minWidth = '220px';
      select.style.height = '36px';
      select.style.border = 'none';
      select.style.borderBottom = '1px solid #999';
      select.style.background = 'transparent';
      select.style.outline = 'none';
      select.style.fontSize = '14px';
      return select;
    },
    write: (args) => {
      const select = Array.isArray(args.elements) ? args.elements[0] : args.elements;
      if (!select) return;

      const currentValue = Array.isArray(args.values) ? args.values[0] : args.values;
      select.innerHTML = '';

      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = groupsLoading ? 'Loading groups...' : 'Select Group';
      placeholder.disabled = true;
      select.appendChild(placeholder);

      groupOptions.forEach((group) => {
        const option = document.createElement('option');
        option.value = group.name;
        option.textContent = group.name;
        select.appendChild(option);
      });

      select.value = currentValue || '';
      select.onchange = (event) => {
        qbRef.current?.notifyChange(event.target.value, event.target, 'value');
      };
    },
    destroy: (element) => {
      if (element) element.onchange = null;
    }
  };

  const queryBuilderColumns = [
    { field: 'name', label: 'Name', type: 'string', operators: stringOperators },
    { field: 'employee_id', label: 'Employee ID', type: 'string', operators: stringOperators },
    { field: 'status', label: 'Status', type: 'string', operators: stringOperators },
    { field: 'department', label: 'Department', type: 'string', operators: stringOperators },
    // { field: 'assigned', label: 'Assigned', type: 'string', operators: stringOperators },
    {
      field: 'group_name',
      label: 'Group',
      type: 'string',
      operators: [{ value: 'equal', key: 'Equal' }],
      values: groupOptions.map(group => group.name),
      template: groupValueTemplate
    },
    { field: 'percentage', label: 'Percentage', type: 'number', operators: numberOperators },
    // { field: 'obtained_marks', label: 'Obtained Marks', type: 'number', operators: numberOperators },
    { field: 'total_marks', label: 'Total Marks', type: 'number', operators: numberOperators }
    // { field: 'percentage', label: 'Score', type: 'number', operators: numberOperators },
    // { field: 'exam_end_time', label: 'Date', type: 'date', format: 'yyyy-MM-dd', operators: dateOperators },
  ];

  const defaultRule = { condition: 'and', rules: [] };

  const hasGroupCondition = (rule) => {
    if (!rule?.rules?.length) return false;

    return rule.rules.some((subRule) =>
      subRule?.rules?.length
        ? hasGroupCondition(subRule)
        : subRule?.field === 'group_name'
    );
  };

  const getGroupRuleValue = (rule) => {
    if (!rule?.rules?.length) return null;

    for (const subRule of rule.rules) {
      if (subRule?.rules?.length) {
        const nestedValue = getGroupRuleValue(subRule);
        if (nestedValue) return nestedValue;
        continue;
      }

      if (subRule?.field === 'group_name') {
        if (Array.isArray(subRule.value)) return subRule.value[0] || null;
        return subRule.value || null;
      }
    }

    return null;
  };

  const syncSelectedGroupFromRule = (rule, options = groupOptions) => {
    if (!hasGroupCondition(rule)) {
      setSelectedGroup(null);
      setGroupEmployees([]);
      setGroupEmployeeFilter(null);
      return;
    }

    const groupValue = getGroupRuleValue(rule);
    const nextSelectedGroup = options.find(group => group.name === groupValue) || null;

    setSelectedGroup(nextSelectedGroup);
    if (!nextSelectedGroup) {
      setGroupEmployees([]);
      setGroupEmployeeFilter(null);
    }
  };

  const removeGroupRules = (rule) => {
    if (!rule?.rules?.length) return rule;

    const rules = rule.rules
      .map((subRule) => subRule?.rules?.length ? removeGroupRules(subRule) : subRule)
      .filter((subRule) => {
        if (subRule?.rules) return subRule.rules.length > 0;
        return subRule?.field !== 'group_name';
      });

    return { ...rule, rules };
  };

  const applyFilters = () => {
    const rule = currentRuleRef.current || defaultRule;
    setFilterRule(removeGroupRules(rule));
    const groupValue = getGroupRuleValue(rule);
    const groupFromRule = groupOptions.find(group => group.name === groupValue) || selectedGroup;
    const isSelectedGroupReady = selectedGroup && groupFromRule?.groupUid === selectedGroup.groupUid;

    if (groupFromRule && isSelectedGroupReady && groupEmployees.length) {
      const employees = Array.from(
        new Map(
          groupEmployees.map(emp => [emp.employee_guid, {
            employee_guid: emp.employee_guid,
            name: emp.name,
            employee_id: emp.employee_id
          }])
        ).values()
      );

      setGroupEmployeeFilter({
        groups: [{
          group_uid: groupFromRule.groupUid,
          group_name: groupFromRule.name,
          employees
        }]
      });
      return;
    }

    setGroupEmployeeFilter(null);
  };

  const clearAllFilters = () => {
    setSearchTerm('');
    setFilterRule(null);
    setSelectedGroup(null);
    setGroupEmployees([]);
    setGroupEmployeeFilter(null);
    if (qbRef.current) {
      qbRef.current.setRules(defaultRule);
      currentRuleRef.current = defaultRule;
    }
  };

  // Existing useEffect for click outside dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setDropdownOpen(false);
    };
    if (dropdownOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dropdownOpen]);

  // Fetch filter options
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(`/reports/filter-options/`, { withCredentials: true });
        const data = response.data;
        setDepartmentOptions(Object.entries(data.departments || {}).map(([id, name]) => ({ id, name })));
        setAssignedOptions(Object.values(data.assignment_types || []));
      } catch (error) {
        console.error('Error fetching filter options:', error);
      }
    };
    fetchOptions();
  }, []);

  useEffect(() => {
    if (!showFilters) return;

    const fetchGroups = async () => {
      try {
        setGroupsLoading(true);
        const response = await axios.get('/coordinators/get_groups_list/?IsActive=true&SortDescending=true', {
          withCredentials: true
        });
        const data = response.data;

        if (data.success) {
          setGroupOptions((data.data || []).map(group => ({
            id: group.GroupId,
            groupUid: group.GroupGUID,
            name: group.Name
          })).filter(group => group.groupUid && group.name));
        }
      } catch (error) {
        console.error('Error fetching groups:', error);
      } finally {
        setGroupsLoading(false);
      }
    };

    fetchGroups();
  }, [showFilters]);

  useEffect(() => {
    syncSelectedGroupFromRule(currentRuleRef.current, groupOptions);
  }, [groupOptions]);

  useEffect(() => {
    const fetchEmployeesForGroups = async () => {
      if (!selectedGroup) {
        setGroupEmployees([]);
        return;
      }

      try {
        setEmployeesLoading(true);
        const response = await axios.get(
          `/coordinators/get_groups_user_by_plant/${selectedGroup.groupUid}/?Page=1&PageSize=500&SortDescending=true`,
          { withCredentials: true }
        );
        const data = response.data;

        if (!data.success) {
          setGroupEmployees([]);
          return;
        }

        setGroupEmployees((data.data || []).map(user => ({
          employee_guid: user.ssoUserId,
          employee_id: user.employeeID,
          name: user.fullName || user.employeeID || 'N/A',
          groupUid: selectedGroup.groupUid,
          groupName: selectedGroup.name
        })).filter(user => user.employee_guid));
      } catch (error) {
        console.error('Error fetching group employees:', error);
        setGroupEmployees([]);
      } finally {
        setEmployeesLoading(false);
      }
    };

    fetchEmployeesForGroups();
  }, [selectedGroup]);

  const handleStatusChange = (status) =>
    setStatusFilters(prev => prev.includes(status) ? prev.filter(s => s !== status) : [...prev, status]);

  const handleDepartmentChange = (id) =>
    setDepartmentFilters(prev => prev.includes(id) ? prev.filter(d => d !== id) : [...prev, id]);

  const handleAssignedChange = (assigned) =>
    setAssignedFilters(prev => prev.includes(assigned) ? prev.filter(a => a !== assigned) : [...prev, assigned]);

  const handleDateChange = (e) => setDateRange({ ...dateRange, [e.target.name]: e.target.value });

  return (
    <>
      {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 2, flexWrap: 'wrap' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1, flexWrap: 'wrap' }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search by Name, Status, Department, Percentage, Total Marks"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              minWidth: 280,
              maxWidth: 450,
              flexGrow: 1,
              '& .MuiOutlinedInput-root': {
                height: '40px',
                fontSize: '0.875rem',
                background: 'white',
                '& fieldset': { borderColor: 'black' },
                '&:hover fieldset': { borderColor: 'black' },
                '&.Mui-focused fieldset': { borderColor: 'black' }
              }
            }}
            InputProps={{
              startAdornment: <SearchIcon sx={{ color: "text.secondary", mr: 1, fontSize: "1.2rem" }} />,
            }}
          />
 
          <button
            className="btn" */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 2,
          width: '100%',
        }}
      >
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search by Name, Employee ID, Status, Department, Percentage, Total Marks"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{
            minWidth: 280,
            maxWidth: 450,
            flexGrow: 1,
            '& .MuiOutlinedInput-root': {
              height: '40px',
              fontSize: '0.875rem',
              background: 'white',
              '& fieldset': { borderColor: 'black' },
              '&:hover fieldset': { borderColor: 'black' },
              '&.Mui-focused fieldset': { borderColor: 'black' },
            },
          }}
          InputProps={{
            startAdornment: (
              <SearchIcon
                sx={{
                  color: 'text.secondary',
                  mr: 1,
                  fontSize: '1.2rem',
                }}
              />
            ),
          }}
        />

        <button
          className="btn"
          style={{
            minWidth: '160px',
            whiteSpace: 'nowrap',
          }}
          onClick={() => {
            if (showFilters) {
              if (qbRef.current) {
                qbRef.current.setRules(defaultRule);
                currentRuleRef.current = defaultRule;
              }

              setSearchTerm('');
              setFilterRule(null);
              setSelectedGroup(null);
              setGroupEmployees([]);
              setGroupEmployeeFilter(null);
            }

            setShowFilters(!showFilters);
          }}
        >
          {showFilters ? 'Close Filters' : 'Enable Filters'}
        </button>


      {/* </Box> */}
      {extraActions && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          {extraActions}
        </Box>
      )}
    </Box >

      {/* Syncfusion QueryBuilder (conditionally visible) */ }
  {
    showFilters && (
      <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1, border: '1px solid #ddd', mb: 2 }}>
        <QueryBuilderComponent
          ref={qbRef}
          key={`employee-report-qb-${groupOptions.length}`}
          dataSource={[]}
          columns={queryBuilderColumns}
          rule={defaultRule}
          ruleChange={(args) => {
            currentRuleRef.current = args.rule;
            syncSelectedGroupFromRule(args.rule);
          }}
          created={() => {
            if (qbRef.current) qbRef.current.setRules(defaultRule);
          }}
          showButtons={false}
          summaryView={false}
        />
        {groupsLoading && (
          <Typography sx={{ mt: 1, fontSize: '0.85rem', color: 'text.secondary' }}>
            Loading groups...
          </Typography>
        )}
        {employeesLoading && (
          <Typography sx={{ mt: 1, fontSize: '0.85rem', color: 'text.secondary' }}>
            Loading group employees...
          </Typography>
        )}
        {selectedGroup && !employeesLoading && (
          <Typography sx={{ mt: 1, fontSize: '0.85rem', color: 'text.secondary' }}>
            {groupEmployees.length} employees from {selectedGroup.name} will be included.
          </Typography>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
          <ButtonComponent cssClass="btn-negative" onClick={clearAllFilters}>
            Clear Filters
          </ButtonComponent>
          <ButtonComponent cssClass="btn" onClick={applyFilters}>
            Apply Filters
          </ButtonComponent>
        </Box>
        {extraActions && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
            {extraActions}
          </Box>
        )}
      </Box>
    )
  }
    </>
  );
};

export default Filters;

